import React from "react";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import GitHubIcon from "@mui/icons-material/GitHub";
import TwitterIcon from "@mui/icons-material/Twitter";
import InstagramIcon from "@mui/icons-material/Instagram";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="w-full bg-[#131315] text-[#f1edfd] py-10 mt-2">
      <div className="mx-5 lg:mx-20 flex flex-col md:flex-row justify-between items-center gap-6">
        {/* Brand / Copyright */}
        <div className="flex flex-col items-center md:items-start gap-2">
          <h2 className="font-Poppins font-bold text-2xl">
            Frantzley <span className="text-[#3aa1ff]">Adolphe</span>
          </h2>
          <p className="font-Inter text-sm text-gray-400">
            © {currentYear} All Rights Reserved.
          </p>
        </div>

        {/* Social Links */}
        <div className="flex flex-row gap-5">
          <a
            href="https://www.linkedin.com/in/frantzley-adolphe-760b4b1b3/"
            target="_blank"
            rel="noreferrer"
            className="text-gray-400 hover:text-[#3aa1ff] transition-colors"
          >
            <LinkedInIcon />
          </a>
          <a
            href="https://github.com/frantzleyadolphe"
            target="_blank"
            rel="noreferrer"
            className="text-gray-400 hover:text-[#3aa1ff] transition-colors"
          >
            <GitHubIcon />
          </a>
          <a
            href="https://twitter.com"
            target="_blank"
            rel="noreferrer"
            className="text-gray-400 hover:text-[#3aa1ff] transition-colors"
          >
            <TwitterIcon />
          </a>
          <a
            href="https://www.instagram.com/frantzley.adolphe/"
            target="_blank"
            rel="noreferrer"
            className="text-gray-400 hover:text-[#3aa1ff] transition-colors"
          >
            <InstagramIcon />
          </a>
        </div>

        {/* Back to top */}
        <div>
          <button
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            className="bg-[#3aa1ff]/10 text-[#3aa1ff] p-3 rounded-full hover:bg-[#3aa1ff] hover:text-[#131315] transition-colors"
            aria-label="Back to top"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={2}
              stroke="currentColor"
              className="w-5 h-5"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M4.5 10.5L12 3m0 0l7.5 7.5M12 3v18"
              />
            </svg>
          </button>
        </div>
      </div>
    </footer>
  );
}
